module.exports = __webpack_public_path__ + "flyer_background_christmas_board_117-e1500d02f564057d0b1e345d62b4f22b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_christmas_board_117.jpg
// module id = 1619
// module chunks = 1